/**
 * Riepilogo di un carrello o di un ordine: righe ("Articoli Nr.") e, subito
 * accanto, i pezzi ordinati (osservazioni del cliente del 30/10/2026, #4).
 */
export function articoliEPezzi(righe: number, pezzi: number): string {
  const p = Math.round(pezzi * 100) / 100;
  return `Nr. ${righe} · ${p.toLocaleString('it-IT')} ${p === 1 ? 'pezzo' : 'pezzi'}`;
}
